/**
 * Outcome of a "Sync now" press on vault settings (PRD-4-5).
 *
 * Turns the HTTP status and body of POST /api/vaults/{vault}/mri/sync into
 * what the page shows and how long the button stays disabled. Pure, so it
 * is unit tested without mounting the component.
 *
 * @param {number|undefined} status HTTP status, undefined when the request never reached the server
 * @param {object|undefined} data   JSON body
 * @returns {{kind: string, message: string, lockSeconds: number}}
 */
export function syncNowOutcome(status, data) {
    const body = data || {};

    if (status === 200 && body.success) {
        return {
            kind: "success",
            message: body.message || "Sync requested. New documents from Strata Master will appear shortly.",
            lockSeconds: positiveSeconds(body.retry_after),
        };
    }

    if (status === 429) {
        return {
            kind: "cooldown",
            message: body.message || "A sync was requested recently. Please try again later.",
            lockSeconds: positiveSeconds(body.retry_after),
        };
    }

    if (status === 403) {
        return {
            kind: "forbidden",
            message: body.message || "You are not authorized for this action",
            lockSeconds: 0,
        };
    }

    if (status === 404) {
        return {
            kind: "unavailable",
            message: body.message || "Strata Master sync is not available for this vault.",
            lockSeconds: 0,
        };
    }

    return {
        kind: "error",
        message: body.message || "Sync could not be requested. Please try again.",
        lockSeconds: 0,
    };
}

function positiveSeconds(value) {
    const seconds = Number(value);

    return Number.isFinite(seconds) && seconds > 0 ? Math.ceil(seconds) : 0;
}
